"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARE_AND_EARN_BANNER = void 0;
const SHARE_AND_EARN_BANNER = exports.SHARE_AND_EARN_BANNER = 'share-and-earn-banner';
//# sourceMappingURL=constants.js.map